export default __webpack_public_path__ + "static/Declaration_EGIB_EN-91738f8a5eced4990548b9a04505bba9.pdf";